module.exports = __webpack_public_path__ + "img/title-bg.576427d2.png";